import { fdc } from "@/helpers/fabricadecodigo"
import axios from 'axios'

export const serviciosService = {
    listarServicios,
    obtenerServicios,
    guardarServicios,
    eliminarServicios,
    selectServicios
}

function listarServicios() {
    return new Promise((resolve, reject) => {
        axios.get(fdc.getHost("/configuracion/servicios"), fdc.getHeader()).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject({ resultado: "error", mensaje: "No fue posible obtener Servicios", "expired": (error.response.status >= 400)});
        });
    })
}

function selectServicios() {
    return new Promise((resolve, reject) => {
        axios.get(fdc.getHost("/data/servicios"), fdc.getHeader()).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject({ resultado: "error", mensaje: "No fue posible obtener Servicios", "expired": (error.response.status >= 400)});
        });
    })
}

function obtenerServicios(id)    {
    return new Promise((resolve, reject) => {
        axios.get(fdc.getHost("/configuracion/servicios/" + id), fdc.getHeader()).then((response) => {
            if (response.data.resultado == "ok")    {
                resolve(response.data)
            } else {
                reject(response.data)
            }
        }).catch((error) => {
            reject({ resultado: "error", mensaje: "No fue posible obtener la servicios", "status": error.response.status });
        })
    });
}

function guardarServicios(request)  {
    return new Promise((resolve, reject) => {
        axios.post(fdc.getHost("/configuracion/servicios"), request, fdc.getHeader()).then((response) => {
            if (response.data.resultado == "ok")    {
                resolve(response.data)
            } else {
                reject(response.data)
            }
        }).catch((error) => {
            reject({ resultado: "error", mensaje: "No fue posible guardar la servicios", "status": error.response.status });
        })
    })
}

function eliminarServicios(id)   {
    return new Promise((resolve, reject) => {
        axios.delete(fdc.getHost("/configuracion/servicios/" + id), fdc.getHeader()).then((response) => {
            if (response.data.resultado == "ok")    {
                resolve(response.data)
            } else {
                reject(response.data)
            }
        }).catch((error) => {
            reject({ resultado: "error", mensaje: "No fue posible eliminar la región", "status": error.response.status });
        })
    })
}
